import { useDispatch, useSelector } from 'react-redux';
import { selectPlayer } from '../ActiveGame/selectors';
import { PICK_TARGET, selectBoardChoice } from '../Board/selectors';
import { choosePickEnergy, pickTarget } from './actions';
import { OPPONENT, PLAYER } from './constants';
import { selectPicksMade, selectPicksStep, selectStepTargets, selectSubmittingPicks } from './selectors';
import { energyWithoutChoice, pickedBefore } from './steps';

/**
 * What tapping a Pokémon does while a Trainer or Power step picks one, or null when the step can't pick it: either
 * player's Pokémon, as the step's `from` says, and never one an earlier step on that side already picked. When the
 * step also takes energy cards and there is a real choice, they are picked next in the menu; otherwise the pick is
 * made.
 *
 * @param {number} userId whose Pokémon it is
 * @param {string|number} at 'active' or a bench position
 * @param {List|undefined} energyAttachments the Pokémon's energy cards
 */
export default function usePickTarget(userId, at, energyAttachments) {
  const dispatch = useDispatch();
  const boardChoice = useSelector(selectBoardChoice);
  const targets = useSelector(selectStepTargets);
  const step = useSelector(selectPicksStep);
  const picks = useSelector(selectPicksMade);
  const submitting = useSelector(selectSubmittingPicks);
  const player = useSelector(selectPlayer);
  const from = userId === player.getIn(['user', 'id']) ? PLAYER : OPPONENT;

  if (boardChoice !== PICK_TARGET || !step || step.get('from') !== from || !targets.includes(at)
    || pickedBefore(picks, from, at)) {
    return null;
  }

  const onClick = () => {
    const energyIds = energyWithoutChoice(step, energyAttachments);
    dispatch(energyIds === null ? choosePickEnergy(from, at) : pickTarget(from, at, energyIds));
  };

  return { onClick, busy: submitting };
}
